export default __webpack_public_path__ + "static/media/arrow-up.bf92bd3f.svg";